import { REQUEST_UPDATE_LANDING_PAGE, UPDATE_LANDING_PAGE_SUCCESS, UPDATE_LANDING_PAGE_ERROR } from './actionTypes';

export const requestUpdateLandingPage = () => ({ type: REQUEST_UPDATE_LANDING_PAGE });

export const updateLandingPageSuccess = landingPage => ({ type: UPDATE_LANDING_PAGE_SUCCESS, payload: landingPage });

export const updateLandingPageError = payload => ({ type: UPDATE_LANDING_PAGE_ERROR, payload });
